export default __webpack_public_path__ + "static/alpaca-finance-leverage-yield-farming-defi-crypto-366d84b8cddccb6b6be78249061cc425.jpeg";